import { render, staticRenderFns } from "./EmployeeAddEdit.vue?vue&type=template&id=2ba6f242&scoped=true"
import script from "./EmployeeAddEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeAddEdit.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeAddEdit.vue?vue&type=style&index=0&id=2ba6f242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6f242",
  null
  
)

export default component.exports